export default __webpack_public_path__ + "static/media/goalbase_navicon-light.dca90b14.svg";